export const formatZoneName = (zoneNumber: number): string => `Zone ${zoneNumber}`;

export const parseZoneNumber = (name: string | undefined | null): number | null => {
  if (name == null) {
    return null;
  }
  const match = name.trim().match(/^Zone\s+(\d+)$/i);
  return match ? Number(match[1]) : null;
};

export const getNextZoneNumber = (
  assignments: { name?: string; localId?: string }[],
  excludeLocalId?: string
): number => {
  let max = 0;
  assignments.forEach((assignment) => {
    if (excludeLocalId && assignment.localId === excludeLocalId) {
      return;
    }
    const zoneNumber = parseZoneNumber(assignment.name);
    if (zoneNumber !== null && zoneNumber > max) {
      max = zoneNumber;
    }
  });
  return max + 1;
};

export const resolveZoneName = (
  name: string | undefined | null,
  assignments: { name?: string; localId?: string }[],
  localId?: string
): string => {
  const trimmed = (name ?? "").trim();
  if (trimmed) {
    return trimmed;
  }
  return formatZoneName(getNextZoneNumber(assignments, localId));
};

export const ensureAssignmentNames = <T extends { name?: string }>(
  assignments: T[]
): (T & { name: string })[] =>
  assignments.map((assignment, index) => ({
    ...assignment,
    name: assignment.name?.trim() || formatZoneName(index + 1),
  }));
